import { styled } from '@nykaa/ui-components';
import Button from 'shared/components/Button';

export const SkipButton = styled(Button)`
    position: absolute;
    width: 150px;
    height: 20px;
    top: -40px;
    ${({ theme }) => `
        border-radius: ${theme.borders.radius20};
        margin-top: ${theme.spacing.spacing10};
        &:focus {
            outline: revert;
            visibility: visible;
            top: 0;
            z-index: 1000;
        }
    `}
    ${({ theme }) => theme.typography.labelMedium};
`;